







import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import enquiryList from '@/components/enquiry-list.vue';
import { EnquiryApi } from '@/api/enquiry-api';
import { ActionConstants } from '@/stores/enquiries/action-constants';
import Enquiry from '@/pages/enquiry.vue';

const Module = namespace('enquiry');

@Component({
    components: {
        layout,
        breadcrumb,
        enquiryList,
    },
})
export default class MyEnquiries extends Vue {
}

